import AuthService from '../services/auth.service';

const loggedData = JSON.parse(localStorage.getItem('loggedData'));
const initialState = loggedData
    ? { status: { loggedIn: true }, loggedData }
    : { status: { loggedIn: false }, loggedData: null };

export const auth = {
    namespaced: true,
    state: initialState,
    actions: {
        login({ commit }, user) {
            return AuthService.login(user).then(
                response => {
                    if (response.status === 'success') {
                        if (response.data.user.email_verified_at !== null) {
                            commit('loginSuccess', response.data);
                        }
                        return Promise.resolve(response);
                    } else {
                        return Promise.reject(response);
                    }
                },
                error => {
                    commit('loginFailure');
                    return Promise.reject(error);
                }
            );
        },
        logout({ commit }) {
            AuthService.logout();
            commit('logout');
        },
        register({ commit }, user) {
            return AuthService.register(user).then(
                response => {
                    commit('registerSuccess');
                    return Promise.resolve(response.data);
                },
                error => {
                    commit('registerFailure');
                    return Promise.reject(error);
                }
            );
        },
        verify({ commit }, user) {
            return AuthService.verify(user).then(
                response => {
                    commit('registerSuccess');
                    return Promise.resolve(response.data);
                },
                error => {
                    commit('registerFailure');
                    return Promise.reject(error);
                }
            );
        },
        resend({ commit }, email) {
            return AuthService.resend(email).then(
                response => {
                    commit('registerSuccess');
                    return Promise.resolve(response.data);
                },
                error => {
                    commit('registerFailure');
                    return Promise.reject(error);
                }
            );
        },
        forgotPassword({ commit }, user) {
            return AuthService.forgotPassword(user).then(
                response => {
                    commit('registerSuccess');
                    return Promise.resolve(response.data);
                },
                error => {
                    commit('registerFailure');
                    return Promise.reject(error);
                }
            );
        },

        resetPassword({ commit }, user) {
            return AuthService.resetPassword(user).then(
                response => {
                    commit('registerSuccess');
                    return Promise.resolve(response.data);
                },
                error => {
                    commit('registerFailure');
                    return Promise.reject(error);
                }
            );
        },
    },
    mutations: {
        loginSuccess(state, loggedData) {
            state.status.loggedIn = true;
            state.loggedData = loggedData;
        },
        loginFailure(state) {
            state.status.loggedIn = false;
            state.loggedData = null;
        },
        logout(state) {
            state.status.loggedIn = false;
            state.loggedData = null;
        },
        registerSuccess(state) {
            state.status.loggedIn = false;
        },
        registerFailure(state) {
            state.status.loggedIn = false;
        }
    }
};
